import { render, staticRenderFns } from "./VipPrivileges.vue?vue&type=template&id=3709c6ba&scoped=true&"
import script from "./VipPrivileges.vue?vue&type=script&lang=js&"
export * from "./VipPrivileges.vue?vue&type=script&lang=js&"
import style0 from "./VipPrivileges.vue?vue&type=style&index=0&id=3709c6ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3709c6ba",
  null
  
)

component.options.__file = "VipPrivileges.vue"
export default component.exports